const params = new URLSearchParams(window.location.search)
const cognitoUserIDCookieName = 'CognitoIdentityServiceProvider.' + window.basic_sso_config.cognito_app_id + '.LastAuthUser'
var cognitoUserIDTokenCookieName = null
var cognitoUserIDToken = null
var userData = null // Used to store profile data we want to use

// Functions
function getCookie(name) {
    let a = `; ${document.cookie}`.match(`;\\s*${name}=([^;]+)`);
    return a ? a[1] : '';
}

function decodeJWT(jwtInput) {

    if (!jwtInput) {
        console.log('No JWT passed');
        return false;
    }

    const parts = jwtInput.split('.');
    if (parts.length !== 3) {
        console.log('Invalid JWT');
        return false;
    }

    try {
        const base64Url = parts[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

        const payload = JSON.parse(jsonPayload);
        // console.log('Profile data',payload)
        return payload
    } catch (e) {
        console.log('Error decoding JWT');
    }
}



//First check if we have received a login token (either via cookie or token passed)
var cognitoUserID = getCookie(cognitoUserIDCookieName)
console.log('Login Cookie User ID', cognitoUserID)

if (cognitoUserID) {
    console.log('Existing cognito user detected')

    cognitoUserIDTokenCookieName =  'CognitoIdentityServiceProvider.' + window.basic_sso_config.cognito_app_id + '.' + cognitoUserID + '.idToken'
    cognitoUserIDToken = getCookie(cognitoUserIDTokenCookieName)

    if (cognitoUserIDToken) {
        console.log('Existing Cognito User ID Token', cognitoUserIDToken)
        userProfile = decodeJWT(cognitoUserIDToken)

        userData = {
            sso_id: userProfile.sub,
            email: userProfile.email
        }

        if(typeof userProfile.address !== "undefined"){
            userData["address"] =  JSON.parse(userProfile.address.formatted)
        }

        if (window.teamstore === undefined) {
            window.teamstore = {
                sso_id: userProfile.sub,
                loyalty_id: userProfile.sub,
                loyalty_sso_cookie: cognitoUserIDToken
            }
        } else {
            window.teamstore['sso_id'] = userProfile.sub;
            window.teamstore['loyalty_id'] = userProfile.sub;
            window.teamstore['loyalty_sso_cookie'] = cognitoUserIDToken;
        }
        // console.log("USER DATA", userData)

    }

} else if(params.get('token')) {
    console.log('Login token passed', params.get('token'))
    cognitoUserIDToken = params.get('token')
}